import React, {useRef, useState} from 'react';
import ReactDOM from "react-dom";

import style from "./productItem.module.scss";
import {CSS} from "@dnd-kit/utilities";
import {GripVertical} from "lucide-react";
import Checkbox from "../../../../components/checkbox/checkbox";
import {useSortable} from "@dnd-kit/sortable";




const ActionsMenu = ({coords, onClose, requestDelete, openProductPopup, categoryId, product}) => {
    if (!coords) return null;
    return ReactDOM.createPortal(
        <div style={{
            top: `${coords.bottom + window.scrollY - 20}px`, // учитываем прокрутку
            left: `${coords.left + window.scrollX - 180}px`
        }}
             className={style.actionsList}
             onClick={(e) => e.stopPropagation()}
             onMouseLeave={()=> {
                 onClose()
             }}
        >
            <button className={style.actionsItem} onClick={() => {
                requestDelete(product);
                onClose();
            }}>Удалить</button>
            <button className={style.actionsItem} onClick={() => {
                openProductPopup({visible: true, categoryId, data: {...product}});
                onClose();
            }}>
                Редактировать
            </button>

        </div>,
        document.body
    );
};




const ProductItem = ({product, update, requestDelete, openProductPopup, categoryId}) => {

    const [actionsIsActive, setActionsIsActive] = useState(false);
    const [coords, setCoords] = useState(null);
    const btnRef = useRef(null);
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition
    } = useSortable({id: product?.id});


    const handleClick = (e) => {
        e.stopPropagation();
        const rect = btnRef.current.getBoundingClientRect();
        setCoords(rect);
        setActionsIsActive(true);
    };

    return (
        <div
            {...attributes}
            className={style.block}
            style={{transform: CSS.Transform.toString(transform),
                transition}}
            ref={setNodeRef}
        >
              <span
                  ref={setActivatorNodeRef}
                  {...listeners}
                  style={{
                      cursor: 'grab',
                      display: 'flex',
                      alignItems: 'center',
                  }}
              >
                <GripVertical size={18} />
              </span>
            <div>{product?.title}</div>
            <Checkbox visible={product?.visible} update={update} id={product.id} />
            <div>{product?.cost}.<span style={{color: "#B2B2B2"}}>00</span></div>

            <div className={style.actions}>
                <button
                    ref={btnRef}
                    className={style.actionsBtn}
                    onClick={handleClick}
                >
                    <svg width="5" height="21" viewBox="0 0 5 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="2.5" cy="2.5" r="2.5" fill="#D9D9D9" />
                        <circle cx="2.5" cy="10.5" r="2.5" fill="#D9D9D9" />
                        <circle cx="2.5" cy="18.5" r="2.5" fill="#D9D9D9" />
                    </svg>
                </button>
            </div>

            {actionsIsActive && (
                <ActionsMenu
                    coords={coords}
                    onClose={() => setActionsIsActive(false)}
                    requestDelete={requestDelete}
                    openProductPopup={openProductPopup}
                    categoryId={categoryId}
                    product={product}
                />
            )}
        </div>
    );
};

export default ProductItem;